<template>
    <a-modal title="评审进度" :visible="visible" style="top:230px" :destroy-on-close="true" :mask-closable="false"
             @cancel="onClose" :width="1000">
        <a-steps v-model:current="current">
            <!--            <template #progressDot="{ prefixCls }">-->
            <!--                <span :class="`${prefixCls}-icon-dot`" />-->
            <!--            </template>-->
            <a-step title="评审结果"/>
            <a-step :disabled="reviewInfo.reviewStatus=='5'" title="专家确认"/>
            <a-step :disabled="!'6,0'.includes(reviewInfo.reviewStatus)" title="评审结束"/>
        </a-steps>
        <div class="steps-content" v-if="current===0">
            <a-descriptions :column="1">
                <a-descriptions-item label="项目名称">{{ reviewInfo.projectReviewName }}</a-descriptions-item>
                <a-descriptions-item label="评审结果">
                    <a-tag v-if="reviewInfo.reviewResult==='5'" color="#1890FF">待补充</a-tag>
                    <a-tag v-if="reviewInfo.reviewResult==='6'" color="#008000">已完成</a-tag>
                    <a-tag v-if="reviewInfo.reviewResult==='0'" color="#FF0000">未通过</a-tag>
                </a-descriptions-item>
                <a-descriptions-item label="评审结果附件">
                    <FileUpload disabled :show-btn="false"
                                v-model:value="reviewInfo.reviewResultAttachment"></FileUpload>
                </a-descriptions-item>
                <a-descriptions-item label="评审建议">{{ reviewInfo.reviewResult==='0'?reviewInfo.noPassReason:reviewInfo.reviewResultAdvise }}</a-descriptions-item>
            </a-descriptions>
        </div>
        <div class="steps-content" v-if="current===1">
            <div class="steps-confirm-box" v-if="Object.keys(confirmList).length>0">
                <div class="left">
                    <div class="item"
                         :class="index==confirmListKey ? 'active-item': ''"
                         v-for="(item,index) in confirmList" :key="item.id" @click="confirmChange(index)">第{{ index }}次专家确认
                    </div>
                </div>
                <div class="right">
                    <a-list size="small" :data-source="confirmList[confirmListKey][0].appendFiles.split(',')">
                        <template #header>
                            <div>补充文件列表</div>
                        </template>
                        <template #renderItem="{ item }">
                            <a-list-item>
                                <div class="listItem">
                                    <div>
                                        <a target="_blank" :href="fileUrl+item" :title="item.split('|')[1]">
                                            {{ item.split('|')[1] }}
                                        </a>
                                    </div>
                                    <div>
                                        <a target="_blank" :href="fileUrl+item">下载</a>
                                    </div>
                                </div>
                            </a-list-item>
                        </template>
                    </a-list>

                    <a-timeline style="margin-top: 25px">
                        <a-timeline-item v-for="item in confirmList[confirmListKey]" :key="item.id">
                            <div v-if="item.auditTime">
                                <div style="color:#000;margin-bottom: 10px;">{{ item.expertName }}<span
                                    style="margin-left: 20px;color:#b7b7b7;">{{ item.auditTime }}</span></div>
                                <div style="background-color: rgb(248, 248, 248);padding:10px 20px;">
                                    <p style="color: #00cc00;margin-bottom: 6px;" v-if="item.auditResult===1">通过</p>
                                    <p style="color: #ff0000;margin-bottom: 6px;" v-if="item.auditResult===0">驳回</p>
                                    <p v-if="item.auditResult!==1">
                                        {{ item.auditResult === 1 ? "通过" : "驳回" }}意见:{{ item.auditAdvise }}
                                    </p>
                                </div>
                            </div>
                            <div v-else>
                                <div style="color:#000;margin-bottom: 10px;">{{ item.expertName }}</div>
                                <div>
                                    待处理
                                </div>
                            </div>
                        </a-timeline-item>
                    </a-timeline>
                </div>
            </div>
        </div>
<!--                <div class="steps-content" v-if="current>0 && current<Object.keys(confirmList).length+1">-->
<!--                    <a-list size="small" :data-source="confirmList[current][0].appendFiles.split(',')">-->
<!--                        <template #header>-->
<!--                            <div>补充文件列表</div>-->
<!--                        </template>-->
<!--                        <template #renderItem="{ item }">-->
<!--                            <a-list-item>-->
<!--                                <div class="listItem">-->
<!--                                    <div>-->
<!--                                        <a target="_blank" :href="fileUrl+item" :title="item.split('|')[1]">-->
<!--                                            {{ item.split('|')[1] }}-->
<!--                                        </a>-->
<!--                                    </div>-->
<!--                                    <div>-->
<!--                                        <a target="_blank" :href="fileUrl+item">下载</a>-->
<!--                                    </div>-->
<!--                                </div>-->
<!--                            </a-list-item>-->
<!--                        </template>-->
<!--                    </a-list>-->

<!--                    <a-timeline style="margin-top: 25px">-->
<!--                        <a-timeline-item v-for="item in confirmList[current]" :key="item.id">-->
<!--                            <div v-if="item.auditTime">-->
<!--                                <div style="color:#000;margin-bottom: 10px;">{{ item.expertName }}<span style="margin-left: 20px;color:#b7b7b7;">{{ item.auditTime }}</span></div>-->
<!--                                <div style="background-color: rgb(248, 248, 248);padding:10px 20px;">-->
<!--                                    <p style="color: #00cc00;margin-bottom: 6px;" v-if="item.auditResult===1">通过</p>-->
<!--                                    <p style="color: #ff0000;margin-bottom: 6px;" v-if="item.auditResult===0">驳回</p>-->
<!--                                    <p v-if="item.auditResult!==1">{{ item.auditResult===1?"通过":"驳回" }}意见: {{ item.auditAdvise }}</p>-->
<!--                                </div>-->
<!--                            </div>-->
<!--                            <div v-else>-->
<!--                                <div>{{ item.expertName }}</div>-->
<!--                                <div>-->
<!--                                    待处理-->
<!--                                </div>-->
<!--                            </div>-->
<!--                        </a-timeline-item>-->
<!--                    </a-timeline>-->
<!--                </div>-->

        <div class="steps-content" v-if="current>0 && current===Object.keys(confirmList).length+1">
            <a-descriptions :column="1">
                <!--                <a-descriptions-item label="项目名称">{{ reviewInfo.projectReviewName }}</a-descriptions-item>-->
                <a-descriptions-item label="评审结果">
                    <a-tag v-if="reviewInfo.reviewStatus==='6'" color="#008000">已完成</a-tag>
                    <a-tag v-if="reviewInfo.reviewStatus==='0'" color="#FF0000">未通过</a-tag>
                </a-descriptions-item>
            </a-descriptions>
        </div>
        <template #footer>
            <a-button key="back" @click="onClose">关闭</a-button>
        </template>
    </a-modal>
</template>

<script>

import {application, confirm} from "@/api/projectReviewService";
import FileUpload from "@/components/form/upload/FileUpload";
import {file_service} from "@/api/adminService";
// import DictSelect from "../../../../../components/other/DictSelect";

export default {
    name: "ProcessPanel",
    components: { FileUpload},
    data() {
        return {
            fileUrl: file_service.download,
            current: 0,
            visible: false,
            reviewId: undefined,
            reviewStatus: undefined,
            reviewInfo: [],
            confirmList: [],
            confirmId:'',
            confirmListKey:1,
        }
    },
    watch: {
        visible(n) {
            if (n) {
                this.getConfirmInfo()

            }
        }
    },
    methods: {
        confirmChange(id){
            this.confirmListKey = id
        },
        onClose() {
            this.visible = false
        },
        getApplicationInfo() {
            this.getAction({
                url: application.detail,
                params: {
                    id: this.reviewId
                }
            }).then(resp => {
                this.reviewInfo = resp
                let confirmLength = Object.keys(this.confirmList).length;
                if (resp.reviewStatus === '3' || resp.reviewStatus === '4') {
                    this.current = 0
                }
                if (resp.reviewStatus === '7') {
                    this.current = 1
                }
                if (resp.reviewStatus === '5' && confirmLength === 0) {
                    this.current = 0
                }
                if (resp.reviewStatus === '5' && confirmLength !== 0) {
                    this.current = 1
                }
                if (resp.reviewStatus === '6' || resp.reviewStatus === '0') {
                    this.current = 2
                }
            })
        },
        async getConfirmInfo() {
            await this.getAction({
                url: confirm.batch,
                params: {
                    applicationId: this.reviewId
                }
            }).then(resp => {
                this.confirmList = resp
                // this.confirmId = this.confirmList[1][0].id
                this.getApplicationInfo()
            })
        }
    }
}
</script>

<style lang="less" scoped>
.steps-confirm-box {
    display: flex;
    justify-content: space-between;
    width: 100%;
    .left {
        width: 16%;

        .item {
            background: #f8f8f8;
            border-bottom: 1px solid #aaaaaa;
            padding: 10px;
            text-align: center;
            color: #999;
            cursor: pointer;
        }

        .active-item{
            background: #1890ff;
            color:#fff;
        }

    }
    .right{
         width: 80%;
    }
}
.steps-content {
    margin-top: 16px;
    border: 1px dashed #e9e9e9;
    border-radius: 6px;
    min-height: 100px;
    padding-top: 10px;
    padding-left: 10px;
}

:deep(.ant-upload-list-item) {
    margin-top: 0;
}

.listItem {
    display: flex;
    justify-content: space-between;
    flex-direction: row;
    flex-wrap: nowrap;
    width: 100%;
}
</style>
